const ROUTE_GENDERS = new Set(["female", "male", "transgender", "shemale"]);

function normalizeGender(rawGender) {
  if (!rawGender) return null;
  if (rawGender === "shemale") return "transgender";
  return ROUTE_GENDERS.has(rawGender) ? rawGender : null;
}

export default function ({ route, store }) {
  const paramGender = normalizeGender(route.params?.gender);
  if (paramGender) {
    store.dispatch("global/saveCurrentGender", paramGender);
    return;
  }

  const pathSegments = route.path.split("/").filter(Boolean);
  for (const segment of pathSegments) {
    const normalized = normalizeGender(segment);
    if (normalized) {
      store.dispatch("global/saveCurrentGender", normalized);
      break;
    }
  }
}
